module.exports = __webpack_public_path__ + "img/default.39eb0bbf.jpg";